import React, { Fragment, useContext, useState } from "react";
import { Menu, Grid, Container,  } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";

import BreadcrumbContainer from "../../app/common/breadcrumb/BreadcrumbContainer";
import { sectionHome } from "../../app/util/breadcrumbOptions";
import { RootStoreContext } from "../../app/stores/rootStore";
import { Role } from "../../app/util/role";
import TenantReportExportForm from "./TenantReportExportForm";


const DashboardReport: React.FC = () => {
  let navigate = useNavigate();
  const match = {
    url: '/home/Report'
  };

  const [showTenantReportForm, setShowTenantReportForm] = useState(false);
  const rootStore = useContext(RootStoreContext);
  const { user } = rootStore.userStore;

  const onCloseTenantReportForm = () => setShowTenantReportForm(false);
  const onOpenTenantReportForm = () => setShowTenantReportForm(true);

  document.title = "Reportes";
  return (
    <div>
      <div className="configurationContent">
        <BreadcrumbContainer title="Reportes" sections={sectionHome} />
      </div>
      <div className="configurationContent">
        <Grid columns={2} stackable textAlign="center">
          <Grid.Row verticalAlign="top">
            <Grid.Column>
              <Menu vertical fluid className="configurationMenu">
                <Menu.Item header className="firstLineConfig">
                  Reportes
                </Menu.Item>
                {user?.role === Role.Sudo && (
                  <Fragment>
                    <Menu.Item
                      name="LiquidacionMensual"
                      onClick={() =>{
                        onCloseTenantReportForm();
                        navigate(`${match.url}/DashboardReportSettlement`)
                      }}
                    >
                      <Container textAlign="left">
                        Liquidación consumo mensual Majim-e
                      </Container>
                    </Menu.Item>

                    <Menu.Item
                      name="AnalisisMensualAgente"
                      onClick={() => {
                        onCloseTenantReportForm();
                        navigate(`${match.url}/DashboardReportBroker`)
                      }}
                    >
                      <Container textAlign="left">
                        Consumo mensual por agente
                      </Container>
                    </Menu.Item>
                  </Fragment>
                )}

                <Menu.Item
                  name="AnalisisMensualCliente"
                  onClick={() => {
                    onCloseTenantReportForm();
                    navigate(`${match.url}/DashboardReportTenant`)
                  }}
                >
                  <Container textAlign="left">
                    Consumo mensual por cliente
                  </Container>
                </Menu.Item>
                <Menu.Item
                  name="MovimientoDetalladoPorCliente"
                  active={showTenantReportForm}
                  onClick={onOpenTenantReportForm}
                >
                  <Container textAlign="left">
                    Movimiento detallado por cliente
                  </Container>
                </Menu.Item>
              </Menu>
            </Grid.Column>
            <Grid.Column key="configurat">
              {showTenantReportForm && ( <TenantReportExportForm /> )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </div>
  );
};

export default observer(DashboardReport);
